<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <AddProductSidebar
        :isSidebarActive="openAddProductSidebar"
        @closeSidebar="toggleAddProductSidebar"
        @getAllProduct="getAllProduct"
      />
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Products</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <div class="mr-4">
            <base-button
              outline
              type="primary"
              class="flex"
              @click="addProduct"
            >
              <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
              Product
            </base-button>
          </div>
          <!-- <div>
            <base-button outline type="primary" class="flex">
           
              <a href="#hello">Pending Request</a>
            </base-button>
          </div> -->
        </div>
      </div>
      <b-input-group class="mt-6">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
            @click="getAllProduct"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <div class="mt-8" v-if="tableData.length != 0">
        <ProductsCard
          :item="item"
          v-for="item in tableData"
          :key="item._id"
          @getAllProduct="getAllProduct"
        />

        <!-- {{ this.tableData }} -->
        <!-- <div class="pt-20">
          <PendingReq
            :item="item"
            v-for="(item, index) in products"
            :key="'item -' + index"
            id="hello"
            class=""
          />
        </div> -->
      </div>
      <div class="mt-9" v-else>No Data</div>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
// import "../../scss/Index.scss";

import ProductsCard from "./components/ProductsCard";
import { mapState } from "vuex";
import AddProductSidebar from "./components/AddProductSidebar";

export default {
  components: {
    ProductsCard,
    AddProductSidebar,
  },
  data() {
    return {
      tableData: [],
      openAddProductSidebar: false,

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
    };
  },
  watch: {
    async currentPage() {
      await this.getAllProduct();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAllProduct();
      }, 500),
    },
  },
  computed: {
    ...mapState("affiliate", {
      products: "products",
      brandData: "brandData",
      vendorProds: "vendorProds",
      getVendor: "getVendor",
    }),
    ...mapState("auth", ["userData"]),
  },
  methods: {
    addProduct() {
      this.toggleAddProductSidebar(true);
    },
    toggleAddProductSidebar(val = false) {
      this.openAddProductSidebar = val;
    },

    async getAllProduct() {
      const vendorId = await this.$store.dispatch("affiliate/getVendorById", {
        userId: this.userData._id,
      });
      // console.log(vendorId, "VNEDOR");
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage * this.perPage,
        userId: this.userData._id,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });
      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        const allProduct = await this.$store.dispatch(
          "affiliate/getVendorProduct",
          payload
        );

        // console.log(allProduct);
        loader.close();

        this.totalRows = this.vendorProds.totalCount;
        this.tableData = this.vendorProds.result;
        // console.log(this.products);
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    // async getAllProduct() {
    //   try {
    //     this.getVendor;
    //   } catch (error) {}
    // },
  },
  async mounted() {
    await this.$store.dispatch("affiliate/getBrand");
    await this.$store.dispatch("subscribe/GetAllMembership");
    await this.getAllProduct();
    // console.log("vendorProds", this.vendorProds);
    // console.log("user", this.brandData);
  },
};
</script>
